import React, { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { hasTrue, isValidURL } from "@/helper/helper";
import { debounce } from "lodash";
import { useConfig } from "@/states/common.state";
import { useSolutionsSelect } from "@/states/solution.state";
import { useUserSocial } from "@/states/qr_types/socialMedia.state";
import { useHandleGenerateResult } from "@/hooks/useHandleGenerateResult";
import { useSignUpModal } from "@/states/ui.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import classes from "./SocialHomepage.module.scss";
import { scrollToTopWithInputFocus } from "@/utils";
import { useTranslations } from "next-intl";
import { useMediaQuery } from "react-responsive";
import { useQrShowState } from "@/states/qr.state";
import TypeInput from "../_shared/TypeInput";
const Social = () => {
  const {
    solutionsSelectedTypes
  } = useSolutionsSelect();
  const {
    handleGenerateResult
  } = useHandleGenerateResult();
  const {
    url,
    setParams
  } = useUserSocial();
  const {
    config,
    payload
  } = useConfig();
  const {
    dashboardQr
  } = useQrShowState();
  const {
    mutateHomeQr,
    isSuccess
  } = useGenerateHomeQr();
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const inputRef = useRef<HTMLInputElement>(null);
  const signupModalState = useSignUpModal();
  const [errors, setErrors] = useState<Array<string> | null>(null);
  const isMobile = useMediaQuery({
    maxWidth: 1025
  });
  const t = useTranslations("QrTypes.linkedin");
  useEffect(() => {
    if (hasTrue(hasTrue(!isFirst, signupModalState.isTriedDownload), isMobile)) {
      setErrors(dashboardQr?.["validation_errors"]?.["url"] ?? null);
    }
  }, [payload, url]);
  useEffect(() => {
    if (signupModalState.isTriedDownload) {
      queueMicrotask(() => {
        setErrors(null);
        setTimeout(() => {
          setErrors(dashboardQr?.["validation_errors"]?.["url"] ?? null);
        }, 200);
      });
    }
  }, [signupModalState.isTempTrigger]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setParams({
      [name]: value,
      isDownload: !(value === "" || !isValidURL(value))
    });
    setIsFirst(false);
  };
  useEffect(() => {
    signupModalState.setIsTriedDownload(false);
    handleGenerateResult(null);
    return () => {
      signupModalState.setIsTriedDownload(false);
    };
  }, []);
  useEffect(() => {
    if (!isFirst) mutateHomeQr({
      params: {
        url,
        config
      }
    });
  }, [url, isFirst]);
  useEffect(() => {
    if (errors) {
      scrollToTopWithInputFocus(inputRef);
    }
  }, [errors]);
  const optimizedFn = useCallback(debounce(handleChange, 500), []);
  const formattedSolutionType = useMemo(() => {
    const type = solutionsSelectedTypes?.toLowerCase();
    return type === "linkedin" ? "LinkedIn" : type;
  }, [solutionsSelectedTypes]);
  return <div className={classes.Wrapper} data-sentry-component="Social" data-sentry-source-file="Social.tsx">
      <div className={classes.Header}>
        <span className={classes.step}>1</span>
        <p className={classes.TopTitle}>
          {t("title")}
        </p>
      </div>
      <div className={classes.Flex}>
        <div className={classes.InputBox}>
          <TypeInput label={t("input.label")} isRequired inputRef={inputRef} errors={errors} name="url" type="text" placeholder={`https://www.${t("input.placeholder")}.com`} defaultValue={url} onChange={e => optimizedFn.call(null, e)} data-sentry-element="TypeInput" data-sentry-source-file="Social.tsx" />
        </div>
      </div>
    </div>;
};
export default Social;